import axios from '../axios'


// 查询医院下的关联关系 传医院id
export const selectRelation = (data) => {
	return axios({
	url: '/api/relation/select',
	method: 'post',
	data: data
	})
};


// // 查询医院下的关联关系 传医院id
// export const yunOffice = (data) => {
// 	return axios({
// 	url: '/api/yun/office/add',
// 	method: 'post',
// 	data: data
// 	})
// };


// WEBPACK FOOTER //
// ./src/http/moudules/hospital.js